import { call, put, takeLatest } from "redux-saga/effects"

// action
import {
    SEND_SIGN_UP_REQUEST,
    SEND_SIGN_UP_REQUEST_FAIL,
    SEND_SIGN_UP_REQUEST_SUCCESS,
    sendSignUpRequestSuccess,
    sendSignUpRequestFail
} from '../action/sendSignUpRequestAction'

// api 
import sendSignUpRequestApi from '../api/sendSIgnUpRequestAPi';


export function* sendSignUpRequestSaga(action) {
    try {
        const response = yield call(() => sendSignUpRequestApi(action.params))
        if (response.data.statusCode === 200) {
            yield put(sendSignUpRequestSuccess(response, action))
        } else {
            yield put(sendSignUpRequestFail(response, action))
        }
    }
    catch (e) {
        yield put(sendSignUpRequestFail(e.response, action))
    }

}

export default function* mySaga() {
    yield takeLatest(SEND_SIGN_UP_REQUEST, sendSignUpRequestSaga)
}
